import React from "react";

export default function HeadquartersSection({
  title,
  subtitle,
  children,
  style = {},
}) {
  return (
    <section
      style={{
        background: "#13293d",
        borderRadius: 12,
        padding: 20,
        border: "1px solid rgba(255,255,255,0.08)",
        marginBottom: 20,
        ...style,
      }}
    >
      {title && (
        <h2
          style={{
            marginTop: 0,
            marginBottom: subtitle ? 8 : 16,
            color: "#ffffff",
          }}
        >
          {title}
        </h2>
      )}

      {subtitle && (
        <div
          style={{
            color: "#9fb0c3",
            marginBottom: 18,
          }}
        >
          {subtitle}
        </div>
      )}

      {children}
    </section>
  );
}
